module.exports = __webpack_public_path__ + "img/01.caafd0b4.svg";